import React from 'react';
import './Products.css';

interface Product {
  name: string;
  tagline: string;
  description: string;
  icon: string;
  url: string;
  tags: string[];
  platform: string[];
}

const products: Product[] = [
  {
    name: 'JOJO',
    tagline: 'Live Video Chat',
    description:
      'JOJO is a real-time live video chat platform that connects people around the world through interactive streaming rooms. Engage with hosts, join live conversations, and experience social entertainment in a vibrant, mobile-first community.',
    icon: 'https://www.sparkjojo.com/favicon.ico',
    url: 'https://www.sparkjojo.com/',
    tags: ['Live Streaming', 'Video Chat', 'Social', 'Entertainment'],
    platform: ['Android', 'Web'],
  },
  {
    name: 'CheeseSync',
    tagline: 'AI Music Video Generator',
    description:
      'CheeseSync transforms your audio, lyrics, and visuals into polished music videos with perfectly synchronized subtitles. Customize fonts, colors, effects, and aspect ratios — then export in landscape or vertical format in minutes.',
    icon: 'https://www.cheesesync.com/static/logo1-banner.png', // TODO: switch to production URL
    url: 'https://www.cheesesync.com/', // TODO: switch to production URL
    tags: ['Music Video', 'AI Generation', 'Subtitles', 'Karaoke'],
    platform: ['Web'],
  },
];

const Products: React.FC = () => {
  return (
    <section className="products" id="products">
      <div className="products-container">
        <div className="section-header">
          <h2 className="section-title">Our Products</h2>
          <p className="products-subtitle">
            Real-world AI-powered products built and shipped by Moosera
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <a
              key={product.name}
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              className="product-card"
            >
              <div className="product-card-inner">
                <div className="product-header">
                  <div className="product-icon-wrap">
                    <img
                      src={product.icon}
                      alt={product.name}
                      className="product-icon"
                      onError={(e) => {
                        (e.target as HTMLImageElement).style.display = 'none';
                      }}
                    />
                  </div>
                  <div className="product-title-group">
                    <h3 className="product-name">{product.name}</h3>
                    <span className="product-tagline">{product.tagline}</span>
                  </div>
                </div>

                <p className="product-description">{product.description}</p>

                <div className="product-tags">
                  {product.tags.map((tag) => (
                    <span key={tag} className="product-tag">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="product-footer">
                  <div className="product-platforms">
                    {product.platform.map((p) => (
                      <span key={p} className="product-platform">
                        {p}
                      </span>
                    ))}
                  </div>
                  <span className="product-link-arrow">Visit →</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
